$(document).ready(function () {
  // タブボタンのクリックイベントリスナーを設定
  $('.c-tab__button').on('click', function () {
    // すべてのタブボタンからアクティブクラスを削除
    $('.c-tab__button').removeClass('c-tab__button--active');
    // クリックされたタブボタンにアクティブクラスを追加
    $(this).addClass('c-tab__button--active');

    // クリックされたタブボタンのIDを取得
    var tabId = $(this).attr('id');
    // 対応するコンテンツのIDを生成
    var contentId = tabId.replace('btn', 'content');

    // すべてのコンテンツからアクティブクラスを削除
    $('.c-tab__content').removeClass('c-tab__content--active');
    // 対応するコンテンツにアクティブクラスを追加
    $('#' + contentId).addClass('c-tab__content--active');
  });
});
